<template>
  <div id="container">
    <div
      v-show="debugMode"
      class="debug"
      ref="refDebug"
      :style="{ left: leftPx + 'px' }"
    >
      <div>
        <div>
          <input
            v-model="wdreceiveChannelName"
            placeholder="channel name"
          /><br />
          <input v-model.number="userId" placeholder="uid" />
        </div>
        <div>
          <label
            ><input type="checkbox" v-model="isShowDevice" />ShowDevice</label
          >
        </div>
        <div class="debug-panel">
          <div @click="furioosVisiable = !furioosVisiable">Furioos</div>
          <div v-show="furioosVisiable">
            <button @click="test">test</button>
            <br />
            micSensitivity<input
              type="range"
              v-model.number="micVolume"
              max="1"
              min="0"
              step="0.01"
            />{{ micVolume }} <br />voiceVol<input
              type="range"
              v-model.number="voiceVolume"
              max="1"
              min="0"
              step="0.01"
            />{{ voiceVolume }} <br />isDesktop: {{ isDesktop }}
            <br />
            micPermission: {{ this.$store.state.micPermission }}
            <br />
            camPermission: {{ this.$store.state.camPermission }}
            <br />
            browserType: {{ browserType }}, seconds: {{ second }}
          </div>
        </div>
        <hr />
        <div>
          <Agora4
            ref="agora4Fun"
            :receiveChannel="wdreceiveChannelName"
            :spatial="spatial"
            :uid="userId"
            :cntStatus="cntStatus"
            :screenEnable.sync="screenEnable"
            :micEnabled.sync="microphoneEnable"
            :micVolume.sync="micVolume"
            :voiceVolume.sync="voiceVolume"
            :webcamEnable.sync="webcamEnable"
            :wdWatch.sync="wdWatch"
            :speakers="speakers"
            :subscribeMode.sync="subscribeMode"
            :isFirefox="isFirefox"
            :isChrome="isChrome"
            :isResetConnect="isResetConnect"
          />
        </div>
        <hr />
        <div>
          <Vivox
            ref="vivoxFun"
            :receiveChannel="wdreceiveChannelName"
            :spatial="spatial"
            :cntStatus="cntStatus"
            :zoneNeedConnect="zoneNeedConnect"
            :wdCheckTime="wdCheckTime"
            :speakers="speakers"
            :subscribeMode="subscribeMode"
          />
        </div>

        <hr />
        <div>
          <SpatialAudio
            ref="hifiFun"
            :receiveChannel="wdreceiveChannelName"
            :spatial="spatial"
            :uid="userId"
            :cntStatus="cntStatus"
            :HifiEnable="vivoxEnable"
            :micEnabled.sync="vMicEnable"
            :micVolume.sync="micVolume"
            :voiceVolume.sync="voiceVolume"
            :wdWatch.sync="vWdWatch"
            :speakers="speakers"
            :subscribeMode="subscribeMode"
            :isFirefox="isFirefox"
            :isResetConnect="isResetConnect"
            :rollOff="spatialRollOff"
          />
        </div>
      </div>
      <div style="height: 25px">
        <button @click="leftDebug = !leftDebug">
          {{ leftDebug ? "show" : "hide" }}
        </button>
      </div>
    </div>
    <div class="inputModule">
      <Keyboard
        ref="inputFun"
        :isDesktop="isDesktop"
        :isIOS="isIOS"
        :isAndroid="isAndroid"
      />
    </div>
    <div id="loading" v-show="loadingShow">
      <img :src="loadingImg" />
    </div>
    <div>
      <Toast ref="toastFun" />
    </div>
    <div>
      <div>
        <input
          hidden
          type="file"
          name="file"
          ref="imageInput"
          accept="image/jpeg,image/png,image/jpg"
          @change="fileChange()"
        />
      </div>
    </div>
    <div class="devicePanel" v-show="isShowDevice">
      <Device
        ref="deviceFun"
        :isShowDevice.sync="isShowDevice"
        :resetEnabled="resetEnabled"
        @closebox="isShowDevice = false"
      />
    </div>
    <div v-show="coverVisiable" class="cover">cover text</div>
    <div>
      <a :href="openUrl" :target="openUrlTarget" ref="linkFun"></a>
    </div>
    <div id="main"></div>
  </div>
</template>

<script>
import { Player } from "furioos-sdk";
import Vivox from "./Vivox";
import Agora4 from "./Agora4";
import SpatialAudio from "./SpatialAudio";
import axios from "axios";
import Device from "./Device";
import Keyboard from "./Keyboard";
import Toast from "./Toast";
import eventBus from "../eventBus";
import device from "current-device";
import eruda from "eruda";

export default {
  components: {
    Vivox,
    SpatialAudio,
    Agora4,
    Device,
    Keyboard,
    Toast,
    eventBus,
  },
  name: "Furioos",
  data() {
    return {
      debugMode: process.env.VUE_APP_DEBUG,
      leftDebug: false,
      leftPx: 0,
      furioosVisiable: false,
      ignorePlayer: false,
      autoLogin: true, //yes or no from url parameter
      gridId: 0, //from url parameter
      gridName: "",
      cookieExpiresDays: 7,
      options: {
        whiteLabel: true,
        hideToolbar: false,
        hideTitle: true,
        hidePlayButton: false,
        // overridedURL: "http://127.0.0.1:8080"
      },
      playerStop: true,
      playerBlackOutTime: 15000,
      playerBlackCount: 0,
      playerBlackInterval: 2000,
      player: {},
      appId: "212.215",
      regionId: "",
      spatialRollOff: 12,
      regionName: "",
      newPlayerActiveStatus: false,
      setUserActiveTimes: 0,
      maxUserActiveTimes: 4,
      toastShow: false,
      toastText: "",
      toastBtnShow: false,
      toastBtnCmd: "",
      openUrl: "",
      openUrlTarget: "_blank",

      zoneNeedConnect: false,
      vivoxEnable: false,
      agoraEnable: false,
      screenEnable: false,
      webcamEnable: false,
      microphoneEnable: false,
      mutedEnable: false,
      vMicEnable: false,
      vMutedEnable: false,
      cntStatus: {
        dcnted: "DISCONNECTED",
        cnting: "CONNECTING",
        cnted: "CONNECTED",
        dcnting: "DISCONNECTING",
      },
      subscribeMode: true, //subscribe remote strem

      micVolume: 0.5,
      voiceVolume: 0.8,

      speakers: [],
      mutedUsers: [],

      agoraInfo: false,
      userId: 0,
      userName: "",
      wdreceiveChannelName: "",
      wdWatch: false,
      wdCheckTime: 5000,
      watchdogFun: null,
      leaveStatus: "", //status when furioos is black screen
      isResetConnect: false, //reset button
      resetTime: 5000,

      vWdWatch: false,

      spatial: false,

      dataResponse: "",
      second: 0,
      timeoutTimer: 0,

      clientHost: false,

      saveTextureInfo: {
        userId: "",
        itemId: "",
        tick: "",
        sessionId: "",
        hash: "",
        gridId: "",
      },
      baseUrl: "",
      cookieId: "",
      isTimeout: false,
      isShowDevice: false,
      inputDeviceId: "default",
      inputVideoDeviceId: "",
      loadingImg: require("@/assets/loading.gif"),
      loadingShow: false,

      coverVisiable: false,

      //log
      logArr: [],
      useLocalStorage: true,

      //common
      isChrome: false,
      isFirefox: false,
      isSafari: false,

      isDesktop: false,
      isIOS: false,
      isAndroid: false,
    };
  },
  computed: {
    resetEnabled: function () {
      return this.wdWatch || this.vWdWatch;
    },
    browserType() {
      if (this.isChrome) {
        return "Chrome";
      } else if (this.isFirefox) {
        return "Firefox";
      } else if (this.isSafari) {
        return "Safari";
      } else {
        return "Unknown";
      }
    },
  },
  watch: {
    leftDebug: function (val) {
      if (val) {
        this.leftPx = -this.$refs.refDebug.offsetWidth + 40;
      } else {
        this.leftPx = 0;
      }
    },
  },
  created: function () {
    console.log(window.location.protocol);
    if (!this.debugMode && window.location.protocol == "http:") {
      let httpUrl = window.location.href;
      let httpsUrl = "https:" + httpUrl.substring(5, httpUrl.length);
      console.log(httpsUrl);
      window.location.href = httpsUrl;
      return;
    }
    var head = document.getElementsByTagName("head")[0];
    let url =
      process.env.VUE_APP_CSS_MAIN_PATH + "/assets_v2/2019/css/custom.css";
    var link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = url;
    head.appendChild(link);

    //log all
    // if(!window.localStorage){
    //   this.useLocalStorage=false;
    // }
    this.useLocalStorage = false;
    localStorage.setItem("furioos", "");
    const origConsoleLog = console.log;
    console.log = (...args) => {
      origConsoleLog.apply(console, args);
      if (this.useLocalStorage) {
        localStorage.setItem(
          "furioos",
          localStorage.getItem("furioos").concat(args)
        );
      } else {
        this.logArr.push(args);
      }
    };
    const origConsoleWarn = console.warn;
    console.warn = (...args) => {
      origConsoleWarn.apply(console, args);
      if (this.useLocalStorage) {
        localStorage.setItem(
          "furioos",
          localStorage.getItem("furioos").concat(args)
        );
      } else {
        this.logArr.push(args);
      }
    };
    const origConsoleError = console.error;
    console.error = (...args) => {
      origConsoleError.apply(console, args);
      if (this.useLocalStorage) {
        localStorage.setItem(
          "furioos",
          localStorage.getItem("furioos").concat(args)
        );
      } else {
        this.logArr.push(args);
      }
    };

    //identify browser
    let userAgent = navigator.userAgent;
    this.isChrome = userAgent.indexOf("Chrome") > -1;
    this.isFirefox = userAgent.indexOf("Firefox") > -1;
    this.isSafari =
      userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1;
  },
  mounted: function () {
    let that = this;
    console.log(Player.regions);
    this.isDesktop = device.desktop();
    this.isIOS = device.ios();
    this.isAndroid = device.android();
    this.userAgentDetect();

    this.watchdogFun = setInterval(this.watchdog, this.wdCheckTime);

    setInterval(() => {
      if (that.playerStop) {
        return;
      }
      that.playerBlackCount = that.playerBlackCount + that.playerBlackInterval;
      // console.log("that.playerBlackCount，", that.playerBlackCount);
      if (that.playerBlackCount >= that.playerBlackOutTime) {
        console.warn("furioos time out and disconnect audio");
        that.wdWatch = false;
        that.vWdWatch = false;
        that.showToast(
          "Please click the refresh button in the browser to reload the page."
        );
      }
    }, this.playerBlackInterval);

    //set value from url parameter
    that.autoLogin = this.$route.query.autologin == "no" ? false : true;
    console.log("autologin:", that.autoLogin);
    if (typeof gridId != "undefined") {
      that.gridId = isNaN(parseInt(gridId)) ? 0 : parseInt(gridId);
    } else {
      that.gridId = isNaN(parseInt(this.$route.query.grid))
        ? 0
        : parseInt(this.$route.query.grid);
    }
    console.log("grid:", that.gridId);

    let queryName = "";
    if (typeof appId != "undefined") {
      queryName = appId;
    } else {
      queryName = this.$route.query.id;
    }

    if (typeof queryName != "undefined") {
      this.appId = queryName;
    }
    console.log("appId:", this.appId);

    let queryRegionId = this.$route.query.regionid;
    if (typeof queryRegionId != "undefined") {
      this.regionId = queryRegionId;
    }
    console.log(this.regionId);

    let queryRegionName = this.$route.query.regionname;
    if (typeof queryRegionName != "undefined") {
      this.regionName = queryRegionName;
    }
    console.log(this.regionName);

    let querySpatialRollOff = this.$route.query.spatialrolloff;
    if (typeof querySpatialRollOff != "undefined") {
      if (parseInt(querySpatialRollOff)) {
        this.spatialRollOff = parseInt(querySpatialRollOff);
      }
    }
    console.log("spatialRollOff:", this.spatialRollOff);

    //let url = baseUrl;
    if (typeof baseUrl != "undefined") {
      this.baseUrl = baseUrl;
    }
    console.log(this.baseUrl);

    //let cookieid = cookieId;
    if (typeof cookieId != "undefined") {
      this.cookieId = cookieId;
    }
    console.log(this.cookieId);

    if (this.ignorePlayer) {
      return;
    }

    this.player = new Player(this.appId, "main", this.options);
    this.player.onLoad(() => {
      console.log("onLoad,player is ready");
      let gridImageUrl = "";
      if (typeof imageUrl != "undefined") {
        gridImageUrl = imageUrl;
      }
      if (typeof gridImageUrl != "undefined" || gridImageUrl != "") {
        this.player.setThumbnailUrl(gridImageUrl);
      }
      let queryContinue = this.$route.query.continue;
      if (typeof queryContinue != "undefined" && queryContinue == "yes") {
        console.log("auto run player");
        this.player.start();
        // this.coverVisiable = true;
      }
      this.player.sendSDKMessage(
        JSON.stringify({
          sinewave: "furioos ready",
          regionid: that.regionId,
          regionname: that.regionName,
        })
      );
    });
    this.player.onAppStart(() => {
      console.log("event onAppStart");
      this.coverVisiable = false;
    });
    this.player.onStreamStart(function () {
      // Implement your own code.
      console.log("Stream started");
      that.isTimeout = false;
      if (typeof sessionQuota != "undefined") {
        let time = Number(sessionQuota);
        if (time >= 0) {
          time = time * 60 * 1000;
          setTimeout(function () {
            console.warn("Time out");
            that.playerStop = true;
            that.wdWatch = false;
            that.closeAgoraDevice();
            that.vWdWatch = false;
            that.closeVivoxDevice();
            that.playerBlackCount = 0;
            that.player.stop();
            that.isTimeout = true;
          }, time);
        }
      }
      if (that.timeoutTimer > 0) {
        return;
      }
      that.timeoutTimer = setInterval(function () {
        if (that.isTimeout) {
          that.second = 0;
          clearInterval(that.timeoutTimer);
          return;
        }
        that.second += 1;
        // console.log(that.second);
        if (that.userId != 0) {
          that.second = 0;
          clearInterval(that.timeoutTimer);
          return;
        }
        if (that.second >= 180) {
          console.warn("Time out");
          that.playerStop = true;
          that.wdWatch = false;
          that.vWdWatch = false;
          that.playerBlackCount = 0;
          that.player.stop();
          that.second = 0;
          clearInterval(that.timeoutTimer);
          return;
        }
      }, 1000);
    });
    this.player.onUserActive(function () {
      console.log("My user is active");
      that.playerStop = false;
      that.player.sendSDKMessage(
        JSON.stringify({
          sinewave: "furioos ready",
          regionid: that.regionId,
          regionname: that.regionName,
        })
      );
    });
    this.player.onUserInactive(function () {
      // Implement your own code.
      console.log("My user is inactive");
      if (that.setUserActiveTimes < that.maxUserActiveTimes - 1) {
        that.player.setUserActive();
        that.setUserActiveTimes++;
        console.log("player.setUserActive(), times:" + that.setUserActiveTimes);
      } else {
        that.showToast(
          "Are you still there?",
          0,
          that.toastRun,
          "setPlayerActive"
        );
        setTimeout(() => {
          that.closeToast();
          if (that.setUserActiveTimes >= that.maxUserActiveTimes - 1) {
            console.warn("furioos time out and disconnect audio");
            that.wdWatch = false;
            that.vWdWatch = false;
          }
        }, 30000);
      }
    });
    this.player.onSessionStopped(function () {
      // Implement your own code.
      console.log("The session has been stopped");
      that.playerStop = true;
      that.wdWatch = false;
      that.closeAgoraDevice();
      that.vWdWatch = false;
      that.closeVivoxDevice();
    });
    this.player.onStats(function (stats) {
      // console.log("event newPlayerActiveStatus: ", stats.userActive);
      if (that.playerStop) {
        that.playerBlackCount = 0;
        that.loadingShow = false;
      } else {
        if (stats.userActive) {
          that.playerBlackCount = 0;
          that.loadingShow = false;
          // that.toastText = "";
          // that.toastShow = false;
          // that.toastBtnShow = false;
        } else {
          if (that.playerBlackCount < that.playerBlackOutTime) {
            that.loadingShow = true;
          }
        }
      }
    });

    this.player.onSDKMessage(function (data) {
      let dataObj = JSON.parse(data);
      console.log("dataObj:", dataObj);
      let sinewave = dataObj.sinewave;
      if (that.playerStop) {
        console.log("playerStop is true return furioos message");
        return;
      }
      switch (sinewave) {
        case "login ready":
          let browserLanguage = that.getCookie("lang");
          console.log(browserLanguage);
          if (browserLanguage == "") {
            browserLanguage = navigator.language.substring(0, 2);
          }
          console.log("browserLanguage: ", browserLanguage);

          if (that.autoLogin) {
            let cookieId = that.getCookie("cookieid");
            if (typeof that.cookieId != "undefined" && that.cookieId != "") {
              cookieId = that.cookieId;
            }
            if (cookieId.toLowerCase() == "null" || cookieId == "undefined") {
              cookieId = "";
            }
            console.log("autologin true, send cookieid");

            that.player.sendSDKMessage(
              JSON.stringify({
                sinewave: "login resume",
                cookieid: cookieId,
                grid: that.gridId,
                regionid: that.regionId,
                regionname: that.regionName,
                browserlanguage: browserLanguage,
              })
            );
          } else {
            console.log("autologin false, send cookieid with empty string");
            that.player.sendSDKMessage(
              JSON.stringify({
                sinewave: "login resume",
                cookieid: "",
                grid: that.gridId,
                regionid: that.regionId,
                regionname: that.regionName,
                browserlanguage: browserLanguage,
              })
            );
          }
          break;
        case "user auth":
          console.log(
            "switch user auth and set cookie: username:" + dataObj.username
          );
          that.setCookie("username", dataObj.username, that.cookieExpiresDays);
          that.userName = dataObj.username;
          that.setCookie("userid", dataObj.userid, that.cookieExpiresDays);
          that.setCookie(
            "cookieid",
            dataObj.cookieid == null ? "" : dataObj.cookieid,
            that.cookieExpiresDays
          );
          that.userId = dataObj.userid;
          break;
        case "voice zone":
          let enabled = dataObj.enabled;
          that.wdWatch = enabled && that.agoraEnable;
          that.vWdWatch = enabled && that.vivoxEnable;
          that.spatial = dataObj.spatial;
          if (enabled) {
            if (dataObj.channel != that.wdreceiveChannelName) {
              if (dataObj.channel != null) {
                that.wdreceiveChannelName = dataObj.channel
                  .replace(/_/g, "")
                  .toLowerCase();
              }
            } else {
              if (that.spatial) {
                // if (dataObj.spatialDistance > 0) {
                //   that.spatialRollOff = dataObj.spatialDistance;
                // }

                that.$refs.hifiFun.updateUserDataTransmit(
                  dataObj.playerPosition,
                  dataObj.playerEuler,
                  that.spatialRollOff
                );
              }
            }
          }
          break;
        case "voice state":
          console.log("switch voice state");
          if (dataObj.enabled) {
            if (dataObj.service == "Agora") {
              that.agoraEnable = true;
              if (that.vWdWatch) {
                that.wdWatch = true;
              }
              that.screenEnable = dataObj.screenshare;
              that.webcamEnable = dataObj.webcam;
              that.microphoneEnable = dataObj.microphone;
              that.mutedEnable = dataObj.muted;
            } else {
              that.vivoxEnable = true;
              that.vMicEnable = dataObj.microphone;
              that.vMutedEnable = dataObj.muted;
            }
          } else {
            if (dataObj.service == "Agora") {
              that.agoraEnable = false;
            } else {
              that.vivoxEnable = false;
            }
          }
          break;
        case "mic volume":
          that.micVolume = dataObj.volume;
          break;
        case "voice volume":
          that.voiceVolume = dataObj.volume;
          break;
        case "open url":
          let url = new RegExp(/^http/i).test(dataObj.url)
            ? dataObj.url
            : "http://" + dataObj.url;
          if (that.isSafari) {
            that.openUrl = url;
            that.openUrlTarget = dataObj.new === false ? "_top" : "_blank";
            that.$refs.linkFun.click();
          } else {
            window.open(url, dataObj.new === false ? "_top" : "_blank");
          }
          break;
        case "upload start":
          console.log("upload start");
          let itemId = dataObj.itemid;
          let userId = dataObj.authplayerid;
          let tick = dataObj.tick;
          let hash = dataObj.hash;
          let sessionId = dataObj.sessionid;
          let gridId = dataObj.gridid;
          that.saveTexture(userId, itemId, tick, sessionId, hash, gridId);
          var interval = setInterval(function () {
            if (that.dataResponse != "") {
              that.player.sendSDKMessage(
                JSON.stringify({
                  sinewave: "upload end",
                  cookieid: "",
                  response: that.dataResponse,
                })
              );
              console.log("Upload success!");
              clearInterval(interval);
              return;
            }
          }, 1000);
          break;
        case "select device":
          console.log("show device");
          that.isShowDevice = true;
          break;
        case "close client":
          console.log("close client");
          that.playerStop = true;
          that.wdWatch = false;
          that.closeAgoraDevice();
          that.vWdWatch = false;
          that.closeVivoxDevice();
          that.playerBlackCount = 0;
          that.player.stop();
          that.showToast("You have logged in again from somewhere else.");
          break;
        case "language":
          that.setCookie("lang", dataObj.type, that.cookieExpiresDays);
          break;
        case "keyboard":
          if (!that.isDesktop) {
            that.$refs.inputFun.setKeyboardFocus(dataObj.value);
          }
          break;
        case "logout":
          console.log("logout client");
          that.playerStop = true;
          that.wdWatch = false;
          that.closeAgoraDevice();
          that.vWdWatch = false;
          that.closeVivoxDevice();
          that.playerBlackCount = 0;
          that.player.stop();
          that.setCookie("cookieid", "", that.cookieExpiresDays);
          break;
        default:
          console.log("no command");
          break;
      }
    });

    let iframe = document.querySelector("iframe");
    iframe.setAttribute("frameborder", "no");
    console.log("jquery:", $("video"));

    document.title =
      typeof gridName != "undefined" ? "Breakroom: " + gridName : "SineSpace";
    this.gridName = document.title;
  },
  methods: {
    debugToggle: function () {
      console.log("debugToggle");
      this.debugMode = !this.debugMode;
    },
    test: function () {
      console.log("test");
      let browserLanguage = this.getCookie("lang");
      console.log(browserLanguage);
      if (browserLanguage == "") {
        browserLanguage = navigator.language.substring(0, 2);
      }
      console.log("browserLanguage: ", browserLanguage);
      this.player.sendSDKMessage(
        JSON.stringify({
          sinewave: "login resume",
          cookieid: "",
          grid: this.gridId,
          regionid: this.regionId,
          regionname: this.regionName,
          browserlanguage: browserLanguage,
        })
      );
    },

    change: function () {
      console.log("change");
      this.screenEnable = !this.screenEnable;
      this.webcamEnable = !this.webcamEnable;
      console.log(this.screenEnable);
      console.log(this.webcamEnable);
    },
    mic: function () {
      this.microphoneEnable = !this.microphoneEnable;
    },
    muted: function () {
      this.mutedEnable = !this.mutedEnable;
    },

    showToast(text, time = 0, btnFun = null, ...btnFunParams) {
      this.$refs.toastFun.showToast(text, time, btnFun, ...btnFunParams);
    },
    closeToast: function () {
      this.$refs.toastFun.closeToast();
    },
    toastRun: async function (cmd) {
      this.$refs.toastFun.closeToast();
      switch (cmd) {
        case "reconnectByMicOpenError":
          await this.$refs.agora4Fun.leaveChannel();
          await this.$refs.agora4Fun.joinChannel();
          break;
        case "setPlayerActive":
          console.log("toastRun setPlayerActive");
          this.setUserActiveTimes = 0;
          this.player.setUserActive();
          break;
        default:
          console.log("toastRun:", cmd);
          break;
      }
    },

    userAgentDetect: function () {
      let userAgent = navigator.userAgent;

      if (userAgent.indexOf("Safari") >= 0 && userAgent.indexOf("Chrome") < 0) {
        this.showToast(
          "Safari is not recommended for World Streaming. For the best experience, please use Google Chrome, Mozilla Firefox or Microsoft Edge."
        );
      }
    },
    saveTexture: function (userId, itemId, tick, sessionId, hash, gridId) {
      this.$refs.imageInput.dispatchEvent(new MouseEvent("click"));
      this.saveTextureInfo.userId = userId;
      this.saveTextureInfo.itemId = itemId;
      this.saveTextureInfo.tick = tick;
      this.saveTextureInfo.sessionId = sessionId;
      this.saveTextureInfo.hash = hash;
      this.saveTextureInfo.gridId = gridId;
    },
    fileChange: function () {
      var formdata = new FormData();
      if (this.$refs.imageInput.files.length == 0) {
        this.$refs.toastFun.showToast("File must not be empty!");
        return;
      }
      let sizeApp = this.$refs.imageInput.files[0].size;
      if (sizeApp / (1024 * 1024) > 5) {
        this.$refs.toastFun.showToast("File size must not be less than 5M!");
        return;
      }
      let AllUpExt = ".jpg|.png|.jpeg|";
      let extName = this.$refs.imageInput.files[0].name
        .substring(this.$refs.imageInput.files[0].name.lastIndexOf("."))
        .toLowerCase();
      if (AllUpExt.indexOf(extName + "|") == "-1") {
        this.$refs.toastFun.showToast("File type error!");
        return;
      }
      let filename = (extName = this.$refs.imageInput.files[0].name);
      filename = filename.split(".")[0];
      formdata.append("fileuploaded", this.$refs.imageInput.files[0]);
      formdata.append("authplayerid", this.saveTextureInfo.userId);
      formdata.append("tick", this.saveTextureInfo.tick);
      formdata.append("sessionid", this.saveTextureInfo.sessionId);
      formdata.append("hash", this.saveTextureInfo.hash);
      formdata.append("itemid", this.saveTextureInfo.itemId);
      formdata.append("name", filename);
      formdata.append("gridid", this.saveTextureInfo.gridId);
      if (this.baseUrl != "") {
        axios
          .post(this.baseUrl + "/worldapi/gameitem/save_texture", formdata)
          .then((response) => {
            console.log(response);
            this.dataResponse = response.data;
          });
      }
    },

    closeAgoraDevice: function () {
      this.screenEnable = false;
      this.webcamEnable = false;
      this.microphoneEnable = false;
      this.mutedEnable = false;
    },
    closeVivoxDevice: function () {
      this.vMicEnable = false;
    },
    resetConnect: function () {
      if (!this.wdWatch && !this.vWdWatch) {
        return;
      }
      eventBus.$emit("reseting", true);
      this.isResetConnect = true;
      setTimeout(() => {
        this.isResetConnect = false;
        eventBus.$emit("reseting", false);
      }, this.resetTime);
    },
    report: function () {
      eventBus.$emit("reporting", true);
      var formdata = new FormData();
      let consoleData = this.useLocalStorage
        ? localStorage.getItem("furioos")
        : this.logArr.join(";\n");
      console.log("console length:", consoleData.length);
      formdata.append("console", consoleData);
      formdata.append("userid", this.userId);
      formdata.append("username", this.userName);
      formdata.append("gridid", this.gridId);
      formdata.append("gridname", this.gridName);
      formdata.append("regionid", this.regionId);
      formdata.append("regionname", this.regionName);
      formdata.append("appid", this.appId);
      formdata.append("url", window.location.href);
      formdata.append("room", this.wdreceiveChannelName);
      formdata.append("agnet", navigator.userAgent);
      formdata.append("isdesktop", this.isDesktop);
      if (this.isChrome) {
        formdata.append("browser", "chrome");
      } else if (this.isSafari) {
        formdata.append("browser", "safari");
      } else {
        formdata.append("browser", "firefox");
      }

      let that = this;
      that.toastText = "report submit";
      that.showToast("report submit");
      axios
        .post(this.baseUrl + "/worldstream/report", formdata)
        .then((response) => {
          console.log(response);
          that.showToast("report success");
          setTimeout(() => {
            that.closeToast();
          }, 2000);
          eventBus.$emit("reporting", false);
        })
        .catch((e) => {
          that.toastText = e.message;
          setTimeout(() => {
            that.closeToast();
          }, 2000);
          eventBus.$emit("reporting", false);
        });
    },
    //command format example: object { sinewave: "microphone", enabled: false }
    sendFurioosMsg(command) {
      let msg = JSON.stringify(command);
      console.log("sendSDKMessage:" + msg);
      this.player.sendSDKMessage(msg);
    },
    sendRemoteAudioData: function (data) {
      let sendData = {
        sinewave: "audio volume",
        data: data,
      };
      let json = JSON.stringify(sendData);
      this.player.sendSDKMessage(json);
    },
  },
};
</script>

<style scoped>
#container,
#main {
  width: 100%;
  height: 100%;
}
#container {
  position: relative;
  /* overflow: hidden; */
}
iframe {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Furioos.vue